<button [matMenuTriggerFor]="columnMenu" mat-icon-button type="button">
  <mat-icon>tune</mat-icon>
</button>

<mat-menu #columnMenu="matMenu">
  @for (column of visibleColumns; track $index) {
    <span
      [disableRipple]="true"
      (click)="toggle(column)"
      mat-menu-item
      rxapStopPropagation
    >
    <mat-checkbox [checked]="column.active" [disabled]="column.disabled">
      {{ column.display }}
    </mat-checkbox>
  </span>
  }
  <ng-content select="[mat-menu-item],mat-divider"></ng-content>
</mat-menu>
